/*             	Leicht 	Durchschnittlich 	Schwer 	Sehr Schwer 	Heldenhaft
common 		    "1-2" 	3-5 			6-9 	10-12 		13-15
novice 		    "1-2" 	3-7 			8-12 	13-16 		17-20
journeyman 	    "3-6" 	7-12 			13-18 	19-22 		23-27
guardian 	    "6-8" 	12-16 			18-24 	25-29 		30-35
master 		    "8-11" 	17-20 			25-28 	29-34 		35-41  */

import {DisciplinesHighestLevel} from "../Char/Disciplines/DisciplinesState";

type tVSRangesLevel = 'common' | 'novice' | 'journeyman' | 'guardian' | 'master';
type tVSRangesDifficulty = 'easy' | 'average' | 'hard' | 'veryhard' | 'heroic';

interface iVSRange {
    f: number;
    t: number;
}

type IDifficulties = {
    [key in tVSRangesDifficulty]: iVSRange;
};

type tVSRanges = {
    [key in tVSRangesLevel]: IDifficulties;
};

interface iVSRanges {
    level: string,
    difficulty: string,
}

export const vsRanges: tVSRanges = {
    common: {
        easy: {f: 1, t: 2},
        average: {f: 3, t: 5},
        hard: {f: 6, t: 9},
        veryhard: {f: 10, t: 12},
        heroic: {f: 13, t: 15}
    },
    novice: {
        easy: {f: 1, t: 2},
        average: {f: 3, t: 7},
        hard: {f: 8, t: 12},
        veryhard: {f: 13, t: 16},
        heroic: {f: 17, t: 20}
    },
    journeyman: {
        easy: {f: 3, t: 6},
        average: {f: 7, t: 12},
        hard: {f: 13, t: 18},
        veryhard: {f: 19, t: 22},
        heroic: {f: 23, t: 27}
    },
    guardian: {
        easy: {f: 6, t: 11},
        average: {f: 12, t: 17},
        hard: {f: 18, t: 24},
        veryhard: {f: 25, t: 29},
        heroic: {f: 30, t: 35}
    },
    master: {
        easy: {f: 8, t: 16},
        average: {f: 17, t: 25},
        hard: {f: 25, t: 28},
        veryhard: {f: 29, t: 34},
        heroic: {f: 35, t: 41}
    }
};

export const vsRangesDifficulties: string[] = ['easy', 'average', 'hard', 'veryhard', 'heroic']

export const vsRangesLevels: string[] = ['common', 'novice', 'journeyman', 'guardian', 'master']

export const vsRangesDisciplineRollInRange = (roll: number) => {

    const level = DisciplinesHighestLevel();
    for (const difficulty in vsRanges[level]) {
        const range: iVSRange = vsRanges[level][difficulty];
        if (roll >= range.f && roll <= range.t) {
            return {level: level, difficulty: difficulty};
        }
    }

    return null;
}

export const vsRangesStepRollInRange = (step: number, roll: number) => {
    /*let inRange: iVSRanges[] = [];
    for (const level in vsRanges) {
        for (const difficulty in vsRanges[level]) {
            const range: iVSRange = vsRanges[level][difficulty];
            if (roll >= range.f && roll <= range.t) {
                inRange.push({level: level, difficulty: difficulty});
            }
        }
    }
    return inRange;*/

    let targetLevel: string | null = null;
    let targetDifficulty: string | null = null;

    for (const level in vsRanges) {
        const averageRange = vsRanges[level].average;
        if (step >= averageRange.f && step <= averageRange.t) {
            targetLevel = level;
            break;
        }
    }

    if (!targetLevel) {
        console.error(`Keine Kategorie für den step-Wert ${step} gefunden.`);
        return null;
    }

    const rollDifficulties = vsRanges[targetLevel];
    for (const difficulty in rollDifficulties) {
        const range = rollDifficulties[difficulty];
        if (roll >= range.f && roll <= range.t) {
            return {
                level: targetLevel,
                difficulty: difficulty
            };
        }
    }

    console.error(`Der Würfelwurf ${roll} passt in keine Kategorie des Levels ${targetLevel}.`);
    return null;
}

export const vsRangesMinRollForDifficulty = (level: tVSRangesLevel, difficulty: tVSRangesDifficulty) => {
    const range = vsRanges[level]?.[difficulty];
    return range ? range.f : null;
}